
















































































































































import Vue from "vue";
import { Button } from "@micad/vue-components";

export default Vue.extend({
  name: "Authenticate",
  components: {
    Button,
  },
  data() {
    return {
      code: 468004,
    };
  },
});
